/**
 * Resolve the explainable-hint copy for a guess row (from the guess object and/or the day's map from the server).
 * @param {{ word: string, hintExplanation?: string|null }} guess
 * @param {Record<string, string>|null|undefined} explanationsByWord — keys match server-normalized words (typically lowercased Latin)
 * @returns {string|null}
 */
export function getHintExplanationForGuess(guess, explanationsByWord) {
  if (!guess || typeof guess.word !== 'string') return null;
  const fromGuess = guess.hintExplanation;
  if (typeof fromGuess === 'string' && fromGuess.trim()) return fromGuess.trim();
  const map = explanationsByWord && typeof explanationsByWord === 'object' && !Array.isArray(explanationsByWord)
    ? explanationsByWord
    : {};
  const w = guess.word.toLowerCase();
  const fromMap = map[w];
  if (typeof fromMap === 'string' && fromMap.trim()) return fromMap.trim();
  return null;
}
